import { render, staticRenderFns } from "./serbestent.vue?vue&type=template&id=50b887a8&"
import script from "./serbestent.vue?vue&type=script&lang=js&"
export * from "./serbestent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports